import { render } from "./AddRolePermissionModal.vue?vue&type=template&id=1f6935f8"
import script from "./AddRolePermissionModal.vue?vue&type=script&lang=js"
export * from "./AddRolePermissionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__